import { targetedFlagsUnknownMessage } from "./SlotTargetedFlagList.js";
import type { SlotTargetedFlags } from "./useSlotTargetedFlags.js";
import styles from "./DbManager.module.css";

export function TargetedFlagsWarning({ targetedFlags }: { targetedFlags: SlotTargetedFlags }) {
  const message =
    targetedFlagsUnknownMessage(targetedFlags) ??
    (targetedFlags.flagKeys.length > 0
      ? `This slot has flags switched on only for it: ${targetedFlags.flagKeys.join(", ")}`
      : null);
  if (!message) return null;

  return (
    <div className={styles.warningBanner} data-testid="make-active-targeted-flags">
      {message}
    </div>
  );
}
